<template>
    <Card>
        <div class="card-body">
            <router-link
                class="btn btn-link"
                :to="{
                    name: 'CreateProjectUserPage'
                }"
            >
                <i class="icon-plus3 mr-2"></i>
                {{ $t('buttons.create') }}
            </router-link>
        </div>
        <div class="table-responsive">
            <FetchTable
                :handle="tableHandle"
                :columns="columns"
                :url="`/projects/${$route.params.projectUuid}/users`"
            >
                <template #td-id="{ row }">
                    <router-link :to="`/app/projects/${$route.params.projectUuid}/access/users/${row.uuid}`">
                        {{ row.id }}
                    </router-link>
                </template>
                <template #td-email="{ row }">
                    <AppNullableCell>
                        <template #default v-if="row.email">
                            {{ row.email }}
                        </template>
                    </AppNullableCell>
                </template>
                <template #td-user="{ row }">
                    <AppNullableCell>
                        <template #default v-if="row.user">
                            {{ getFullName(row.user) }}
                        </template>
                    </AppNullableCell>
                </template>
                <template #td-approved_at="{ row }">
                    <AppNullableCell>
                        <template #default v-if="row.approved_at">
                            {{ DateFormatter.formatDateTime(row.approved_at) }}
                        </template>
                    </AppNullableCell>
                </template>
                <template #td-created_at="{ row }">
                    <AppNullableCell>
                        <template #default v-if="row.created_at">
                            {{ DateFormatter.formatDateTime(row.created_at) }}
                        </template>
                    </AppNullableCell>
                </template>
            </FetchTable>
        </div>
    </Card>
</template>
<script>
import Card from '../../../../../components/new/CardComponent.vue';
import FetchTable from '../../../../../components/new/table/FetchTable.vue';
import { createTableHandle } from '../../../../../components/new/table/tableHandle';
import AppNullableCell from '../../../../components/tables/AppNullableCell.vue';
import DateFormatter from '../../../../../services/DateFormatter';

export default {
    name: "IndexProjectUsersPage",
    components: {
        Card, FetchTable, AppNullableCell
    },
    data() {
        return {
            tableHandle: createTableHandle(),
            DateFormatter,
            columns: [
                { key: 'id', name: this.$t('table.titles.id'), width: '80px', type: 'string', order: true },
                { key: 'email', name: this.$t('table.titles.email'), width: '150px', type: 'string', order: true },
                { key: 'user', name: this.$t('table.titles.user'), width: '150px', type: 'string', order: true },
                { key: 'approved_at', name: this.$t('table.titles.approved_at'), width: '150px', type: 'string', order: true },
                { key: 'created_at', name: this.$t('table.titles.created_at'), width: '150px', type: 'string', order: true },
            ]
        }
    },
    methods: {
        fetchUsers() {
            this.tableHandle.fetchRows();
        },
        getFullName(user) {
            return user.full_name;
        }
    },
    mounted() {
        this.fetchUsers();
    }
};
</script>
